"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceDataMaskT = exports.DeviceDataMask = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const tracker_data_mask_js_1 = require("../../../solarxr-protocol/data-feed/tracker/tracker-data-mask.js");
/**
 * A mask of values to be reported in subsequent DeviceStatus. Values set to `false`
 * or `null` will not reported. By default, all fields are false/null.
 *
 * If you set a value to `true`, it is not guaranteed that the sender actually has
 * such a value to send. In this case, they will probably send `null`, and the receiver
 * has the choice to disconnect due to missing data.
 */
class DeviceDataMask {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsDeviceDataMask(bb, obj) {
        return (obj || new DeviceDataMask()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsDeviceDataMask(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new DeviceDataMask()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    /**
     * Which tracker data should be sent in this data feed
     */
    trackerData(obj) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? (obj || new tracker_data_mask_js_1.TrackerDataMask()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    /**
     * true if device data should be sent in this data feed
     */
    deviceData() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    static startDeviceDataMask(builder) {
        builder.startObject(2);
    }
    static addTrackerData(builder, trackerDataOffset) {
        builder.addFieldOffset(0, trackerDataOffset, 0);
    }
    static addDeviceData(builder, deviceData) {
        builder.addFieldInt8(1, +deviceData, +false);
    }
    static endDeviceDataMask(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createDeviceDataMask(builder, trackerDataOffset, deviceData) {
        DeviceDataMask.startDeviceDataMask(builder);
        DeviceDataMask.addTrackerData(builder, trackerDataOffset);
        DeviceDataMask.addDeviceData(builder, deviceData);
        return DeviceDataMask.endDeviceDataMask(builder);
    }
    unpack() {
        return new DeviceDataMaskT((this.trackerData() !== null ? this.trackerData().unpack() : null), this.deviceData());
    }
    unpackTo(_o) {
        _o.trackerData = (this.trackerData() !== null ? this.trackerData().unpack() : null);
        _o.deviceData = this.deviceData();
    }
}
exports.DeviceDataMask = DeviceDataMask;
class DeviceDataMaskT {
    constructor(trackerData = null, deviceData = false) {
        this.trackerData = trackerData;
        this.deviceData = deviceData;
    }
    pack(builder) {
        const trackerData = (this.trackerData !== null ? this.trackerData.pack(builder) : 0);
        return DeviceDataMask.createDeviceDataMask(builder, trackerData, this.deviceData);
    }
}
exports.DeviceDataMaskT = DeviceDataMaskT;
